import type { ActiveSession } from '../shared/types';

/** Called while the caller owns the IndexedDB queue+state write transaction. */
export function chooseRemoteRecord(remote: ActiveSession, current: ActiveSession | null, baseline: ActiveSession | null, pending: boolean): ActiveSession {
  if (current && (pending || JSON.stringify(current) !== JSON.stringify(baseline))) return current;
  return remote;
}
